import React, { useEffect, useState } from "react";
import LeftMenu from "../../../components/layout/leftMenu";
import Header from "../../../components/layout/header";
import { useSelector } from "../../../components/hooks/hooks";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import { ShimmerCategoryItem } from "react-shimmer-effects";
import { ToastContainer } from "react-toastify";
import { backendApi } from "../../../api/apiService";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { FiDownload } from "react-icons/fi";
import * as XLSX from "xlsx-js-style";

export default function AnalyticsReport() {
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.login);
  const [menuClick, setMenuClick] = useState(false);
  const [vacancyReport, setVacancyReport] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSchedulRecruitmentReports();
  }, []);

  const toggleMenu = () => setMenuClick(!menuClick);
  const closeMenu = () => setMenuClick(false);
  const handleBack = () => navigate('/dashboard/reports');

  const getSchedulRecruitmentReports = () => {
    setLoading(true); // Start loader before API call
    const api = {
      functionName: "schedulRerecruitmentReports",
      site_id: userDetails[0]?.site_id,
    };

    backendApi(api)
      .then((response) => {
        if (response.success === "1") {
          setVacancyReport(response.dataSet);
        }
      })
      .catch((error) => {
        console.error("Error fetching reports:", error);
      })
      .finally(() => setLoading(false)); // Stop loader after response
  };

  // ========================= DOWNLOAD EXCEL ==============================
  const handleDownload = () => {
    if (!vacancyReport || vacancyReport.length === 0) {
      alert("No data to download");
      return;
    }

    const dataToExport = vacancyReport.map((openings) => {
      const statusDetails =
        openings.status && openings.status.length > 0
          ? openings.status
            .map(
              (s) =>
                `${s.full_name || "N/A"} (${s.category_type || "N/A"} - ${s.cnt || 0
                })`
            )
            .join(", ")
          : "In Progress";

      return {
        Summary: openings.summary || "",
        "Openings Available": openings.no_of_position || "",
        "Start Date": openings.start_date
          ? moment(openings.start_date).format("DD-MM-YYYY")
          : "",
        "End Date": openings.end_date
          ? moment(openings.end_date).format("DD-MM-YYYY")
          : "",
        "Reporting Managers": openings.reporting_managers_name || "",
        Recruiters: openings.recruiter_name || "",
        "Status (Full Name - Type - Count)": statusDetails,
        Comments: openings.comments || "",
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);

    // Set fixed column widths
    worksheet["!cols"] = [
      { wch: 25 }, // Summary
      { wch: 18 }, // Openings
      { wch: 15 }, // Start Date
      { wch: 15 }, // End Date
      { wch: 25 }, // Reporting Managers
      { wch: 25 }, // Recruiters
      { wch: 50 }, // Status with full name
      { wch: 30 }, // Comments
    ];

    // Style the header row
    const headerCells = Object.keys(dataToExport[0]);
    headerCells.forEach((header, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
      if (!worksheet[cellAddress]) return;
      worksheet[cellAddress].s = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "4472C4" } },
        alignment: { horizontal: "center", vertical: "center" },
        border: {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } },
        },
      };
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Requirement Analytics");

    XLSX.writeFile(workbook, "Requirement_Analytics.xlsx");
  };


  return (
    <div className="main-wrapper">
      <div className="top-color"></div>
      <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
      <div className="content-wrapper">
        <Header Header="Reports" toggleMenu={toggleMenu} menuClick={menuClick} />
        <div className="main-container">
          <ToastContainer containerId={"D"} position="bottom-right" autoClose={1500} theme="colored" />

          <div className="card main-card">
            <div className="card-body">
              <h4 className="dash-sub-head">Requirement Analytics</h4>
              <div class="text-end mb-3">
                <button class="btn-btn btn btn-btn2 btn-sm ml-auto" onClick={handleDownload}><FiDownload /> Download</button>
              </div>
              <div className="table-responsive">
                <table className="table mb-0">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}>Summary</th>
                      <th style={{ width: "50px" }}>Openings Available</th>
                      <th style={{ width: "80px" }}>Date</th>
                      <th style={{ width: "80px" }}>Reporting Managers</th>
                      <th style={{ width: "80px" }}>Recruiters</th>
                      <th style={{ width: "80px" }}>Status</th>
                      <th style={{ width: "80px" }}>Comments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="7" className="text-center">
                          <ShimmerCategoryItem items={12} />
                        </td>
                      </tr>
                    ) : vacancyReport.length > 0 ? (
                      vacancyReport.map((openings, index) => (
                        <tr key={`vacancyReport_${index}`}>
                          <td>{openings.summary}</td>
                          <td>{openings.no_of_position}</td>
                          <td>
                            {moment(openings.start_date).format("DD-MM-yyyy")} <br />
                            to <br />
                            {moment(openings.end_date).format("DD-MM-yyyy")}
                          </td>
                          <td>{openings.reporting_managers_name}</td>
                          <td>{openings.recruiter_name}</td>
                          <td>
                            {openings.status.length > 0 ? (
                              openings.status.map((opn, idx) => (
                                <table key={idx} className="table mb-0">
                                  <tbody>
                                    <tr>
                                      <td className="py-1 px-0 border-0">
                                        {opn.category_type} - {opn.cnt}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              ))
                            ) : (
                              <p>In Progress</p>
                            )}
                          </td>
                          <td>{openings.comments}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">No Openings Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <button type="button" className="floating-back-button" onClick={handleBack}>
            <BsArrowLeftCircleFill size={24} />
          </button>
        </div>
      </div>
    </div>
  );
}
